import { Component } from '@angular/core';
import { DialogBaseComponent } from './dialog_base.component';
import { IntegrateState } from '../state/integrate_state';
import { Store } from '@ngrx/store';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { RedirectService } from '../../../shared/services/redirect.service';
import { defaultManualSetupStates } from '../main/manual_setup/store/constants/steps_constans';
import { NavigationItem } from '../../shared/navigation/navigation_item';
import { navFinishInstallation } from '../../shared/navigation/state/navigation_actions_creator';
import { IAppState } from '../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-integrate-install-it-myself-dialog',
  template: require('./install_it_myself.component.html'),
  styles: [require('./install_it_myself.component.scss')]
})
export class InstallItMyselfComponent extends DialogBaseComponent {

  private platform;
  private currentStep: NavigationItem;
  private isWidgetV3: boolean;

  constructor(private redCrossService: AnalyticsTrackingProvider,
              private store: Store<IAppState>,
              private redirectService: RedirectService) {
    super('Install It Yourself', redCrossService);

    this.store.select(state => state.app.install.integrate).subscribe(
      (state: IntegrateState) => {
          this.platform = defaultManualSetupStates[state.platform][0];
          this.isWidgetV3 = state.hasWidgetV3;
      });

    this.store.select(state => state.app.install.navigation).subscribe(
      items => {
        this.currentStep = items.navigationItems.filter(item => item.active === true)[0];
      });
  }

  openInstallationGuide() {
    this.redCrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Open Installation Guide'
    });
    this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
      product: REDCRSS_EVENTS.PRODUCT,
      stepName: REDCRSS_EVENTS.INTEGRATE,
      stepNum: 3,
      status: REDCRSS_EVENTS.COMPLETED,
      isSkipped: 1,
      isWidgetV3: this.isWidgetV3,
      endScenario: REDCRSS_EVENTS.INSTALL_LATER
    });
    this.redirectService.redirectTo(this.platform.installationGuideLink, true);
    this.store.dispatch(navFinishInstallation({finishedStep: this.currentStep}));
  }
}




